import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as Common from "../../../store/common";
import * as LoginActions from "../../../store/loginService/actions";
import * as ConfigurationActions from "../../../store/configurationService/actions";
import { ApplicationState } from "../../../store";
import moment from "moment-timezone";
import { IPackage } from "../../../store/protectionPlanService/idf/types";
import * as packageUpgradeDowngradeAction from "../../../store/packageUpgradeService/actions";
import * as BreachActions from "../../../store/breachService/actions";
import RenderIcons from "../../../Assets/css/_icons/partner_icon/RenderIcons";
interface IProps {
    closeDialog: any;
    dialogId: string;
    nextOperationDate: string;
    packageIndex: number;
    history: any;
}

const IDFProtectionPlanUpgradeCompleteDialog: React.FunctionComponent<IProps> = (props) => {
    const dispatch = useDispatch();
    const partnerPhoneNumber: string = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.phoneNumber
            ? state.configurationState.configuration.partnerConfig.phoneNumber
            : ""
    );
    const packageList = useSelector((state: ApplicationState) => {
        if (state.protectionPlanIdfState && state.protectionPlanIdfState.protectionPlanData) {
            return state.protectionPlanIdfState.protectionPlanData.packageList;
        }
    });

    const selectedPackage = (packageList && packageList.length >= props.packageIndex ? packageList[props.packageIndex] : null) as IPackage;
    const requestPackageData = () => dispatch(packageUpgradeDowngradeAction.actionCreators.requestPackageData());
    const requestServiceCatalog = () => dispatch(BreachActions.actionCreators.requestBreachService());
    const closeUpgradeCompleteDialog = () => {
        if (selectedPackage?.ActionButtonText?.toLowerCase() === "cancel" && !props.nextOperationDate) {
            dispatch(LoginActions.actionCreators.logout(props.history));
            dispatch(ConfigurationActions.actionCreators.getRedirectTokenAction(""));
            requestServiceCatalog();
        } else if (selectedPackage?.ActionButtonText?.toLowerCase() === "cancel") {
            dispatch({ type: "RELOAD_USER_PERMISSION" });
            dispatch({ type: "GET_USER_SERVICES", userServices: null });
            requestPackageData();
            requestServiceCatalog();
            props.closeDialog();
        } else {
            dispatch(Common.actionCreators.refreshUserPermission());
            requestPackageData();
            requestServiceCatalog();
            props.closeDialog();
        }
    };

    useEffect(() => {
        document.querySelector<any>(`[aria-labelledby=${props.dialogId}-title]`)!.classList.add("width-lg");

        window.addEventListener("keyup", (evt: any) => {
            evt = evt || window.event;
            var isEscape = false;
            if ("key" in evt) {
                isEscape = evt.key === "Escape" || evt.key === "Esc";
            } else {
                isEscape = evt.keyCode === 27;
            }
            if (isEscape) {
                closeUpgradeCompleteDialog();
            }
        });
        return () => {
            window.removeEventListener("keyup", () => {});
        };
    });

    const textForCancellation = () => {
        return (
            <React.Fragment>
                {props.nextOperationDate ? (
                    <React.Fragment>
                        <p>
                            This account will be canceled on {moment(props.nextOperationDate, "YYYY-MM-DD").format("M/D/YYYY")}, the end of your current billing, as
                            you requested.
                            <br />
                            If you change your mind before the cancellation takes effect, please call Member Services at{" "}
                            <a href={'tel:"' + partnerPhoneNumber + '"'}>{partnerPhoneNumber}</a>.
                        </p>
                    </React.Fragment>
                ) : (
                    <p>Your order has been processed and your changes applied to your account.</p>
                )}
            </React.Fragment>
        );
    };

    const textForUpgrade = () => {
        return (
            <React.Fragment>
                <p>Your plan has been successfully updated.</p>
            </React.Fragment>
        );
    };

    return (
        <React.Fragment>
            <div className="dialog-header">
                <div className="dialog-icon">
                    <RenderIcons iconName="cube" />
                </div>
                <h1>Thank You!</h1>
            </div>

            <div className="dialog-body">
                <div className="form-row inline row">
                    {selectedPackage?.ActionButtonText?.toLowerCase() === "cancel" ? textForCancellation() : textForUpgrade()}
                </div>
            </div>

            <div className="dialog-footer">
                <div className="row between-xs">
                    <div className="col-xs col-no-gutter flex-grow-null"></div>
                    <div className="col-xs col-no-gutter flex-grow-null">
                        <button
                            type="submit"
                            className="btn-default btn-primary"
                            id="btn-submit-purchase"
                            onClick={() => {
                                window.addToDataLayer({ event: "Protection Plan - Close completion" });
                                closeUpgradeCompleteDialog();
                            }}
                        >
                            <span className="btn-text">Close</span>
                        </button>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};
export default IDFProtectionPlanUpgradeCompleteDialog;
